module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-load-check",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n        Weighbridge Details for " + _vm._s(_vm.loadDecorated.reference_number) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Date")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.weighbridgeDecorated.date) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v(" "), _c('span', {
    class: _vm.weighbridgeDecorated.status_class
  }, [_vm._v(_vm._s(_vm.weighbridgeDecorated.status_text))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Vehicle Rego")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.loadDecorated.registration) + "\n                ")])]), _vm._v(" "), (!_vm.$user.isClient) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Configuration")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.loadDecorated.configuration_description) + "\n                ")])]) : _vm._e(), _vm._v(" "), (!_vm.$user.isClient) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details truncate"
  }, [_c('strong', [_vm._v("From")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.loadDecorated.location_from && _vm.loadDecorated.location_from.formatted_name) + "\n                ")])]) : _vm._e(), _vm._v(" "), (!_vm.$user.isClient) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details truncate"
  }, [_c('strong', [_vm._v("To")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.loadDecorated.location_to && _vm.loadDecorated.location_to.formatted_name) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Total Net Delivered")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.weighbridgeDecorated.total_tonnage) + "t\n                ")])]), _vm._v(" "), (!_vm.$user.isClient) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Commodity")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.loadDecorated.commodityName) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Pickup Reference")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.jobDecorated.pickup_reference) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Delivery Reference")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.jobDecorated.delivery_reference) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Order")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.jobDecorated.order_reference) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Driver Notes")]), _c('br'), _vm._v("\n                  " + _vm._s(_vm.load.notes) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabName === 'delivery'),
      expression: "tabName === 'delivery'"
    }],
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Delivery Date")]), _c('br'), _vm._v(" "), _c('date-range', {
    attrs: {
      "single-date-picker": true,
      "opens": "right",
      "drops": "up",
      "placeholder": "00/00/0000",
      "name": "delivery_date"
    },
    model: {
      value: (_vm.deliveryDate),
      callback: function($$v) {
        _vm.deliveryDate = $$v
      },
      expression: "deliveryDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabName === 'delivery'),
      expression: "tabName === 'delivery'"
    }],
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Delivery Time")]), _c('br'), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.flatPickerConfig,
      "placeholder": "9:00 AM"
    },
    model: {
      value: (_vm.deliveryTime),
      callback: function($$v) {
        _vm.deliveryTime = $$v
      },
      expression: "deliveryTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabName === 'pickup'),
      expression: "tabName === 'pickup'"
    }],
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Loading Date")]), _c('br'), _vm._v(" "), _c('date-range', {
    attrs: {
      "single-date-picker": true,
      "opens": "right",
      "drops": "up",
      "placeholder": "00/00/0000",
      "name": "loading_date"
    },
    model: {
      value: (_vm.loadingDate),
      callback: function($$v) {
        _vm.loadingDate = $$v
      },
      expression: "loadingDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabName === 'pickup'),
      expression: "tabName === 'pickup'"
    }],
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Loading Time")]), _c('br'), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.flatPickerConfig,
      "placeholder": "9:00 AM"
    },
    model: {
      value: (_vm.loadingTime),
      callback: function($$v) {
        _vm.loadingTime = $$v
      },
      expression: "loadingTime"
    }
  })], 1)])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs m-t-md"
  }, [_c('li', {
    class: {
      'active': _vm.commodityTypeIsDelivery
    }
  }, [_c('a', {
    attrs: {
      "href": "#delivery",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.tabName = 'delivery'
      }
    }
  }, [_vm._v("Delivery (" + _vm._s(_vm.deliveryDockets.length) + ")")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.commodityTypeIsPickup
    }
  }, [_c('a', {
    attrs: {
      "href": "#pickup",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.tabName = 'pickup'
      }
    }
  }, [_vm._v("Pickup (" + _vm._s(_vm.pickupDockets.length) + ")")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#connote",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        _vm.tabName = 'connote'
      }
    }
  }, [_vm._v("Con-note (" + _vm._s(_vm.conNotes.length) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane",
    class: {
      'active': _vm.commodityTypeIsDelivery
    },
    attrs: {
      "id": "delivery"
    }
  }, [_c('ul', {
    staticClass: "load-dockets"
  }, [_vm._l((_vm.deliveryDockets), function(docket) {
    return _c('load-check-modal-item', {
      key: docket.id,
      attrs: {
        "docket": docket
      }
    })
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.deliveryDockets.length),
      expression: "!deliveryDockets.length"
    }],
    staticClass: "text-center text-muted"
  }, [_vm._v("\n                    No delivery dockets.\n                  ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    class: {
      'active': _vm.commodityTypeIsPickup
    },
    attrs: {
      "id": "pickup"
    }
  }, [_c('ul', {
    staticClass: "load-dockets"
  }, [_vm._l((_vm.pickupDockets), function(docket) {
    return _c('load-check-modal-item', {
      key: docket.id,
      attrs: {
        "docket": docket
      }
    })
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pickupDockets.length),
      expression: "!pickupDockets.length"
    }],
    staticClass: "text-center text-muted"
  }, [_vm._v("\n                    No pickup dockets.\n                  ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "connote"
    }
  }, [_c('ul', {
    staticClass: "load-dockets"
  }, [_vm._l((_vm.conNotes), function(docket) {
    return _c('load-check-modal-item', {
      key: docket.id,
      attrs: {
        "docket": docket
      },
      on: {
        "update-delivery-time": _vm.updateDeliveryTime
      }
    })
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.conNotes.length),
      expression: "!conNotes.length"
    }],
    staticClass: "text-center text-muted"
  }, [_vm._v("\n                    No consignment notes.\n                  ")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('load-check-modal-preview')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.haveNextLoad) ? _c('button', {
    staticClass: "btn btn-sm btn-default",
    on: {
      "click": _vm.goToNextLoad
    }
  }, [_vm._v("Next Load")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-065478cf"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/LoadCheckModal.vue
// module id = 922
// module chunks = 0